<script>
/**
 * @param status {String} options are: primary, success, warning, error
 */
export let status = "danger";
export let is_icon_align = false;
export let main_classes = "";
export let title_classes = "";
export let icon_class = "icon-tripod-alert-outlined";
export let styles_container = "";
export let has_icon = true;

if(status === "info") {
    status = "primary";
}

if(status === "error"){
    status = "danger";
}

if(status === ""){
    status = "danger";
}

</script>
<notification-dialog role="alertdialog" class="notification-box {status} is-flex is-align-items-center p-alt-4 gap-alt-6" aria-hidden="true" style="{styles_container}">
    <header class={is_icon_align ? 'is-align-self-flex-start' : ''}>
        {#if has_icon && !$$slots.icon}
            <figure>
                <i class="{icon_class} has-text-{status} font-restricted-size-40"></i>
            </figure>
        {/if}
        <slot name="icon" />
    </header>
    <main class="{main_classes} is-grid is-gap-10">
        <h3 class="fw600 font-size-16 {title_classes}">
            <slot name="title"></slot>
        </h3>
        <p class="font-size-14">
            <slot></slot>
        </p>
    </main>
</notification-dialog>
<style>
notification-dialog{
    display: block;
    width: 100%;
    text-align: left;
    min-height: 90px;
    border-width: 1px; 
    border-style: solid;
    border-radius: 8px;
}
notification-dialog:global(.danger), notification-dialog:global(.error){
    border-color: var(--color-error);
    background-color: #fff0f0;
}
notification-dialog:global(.warning){
    border-color: var(--color-warning);
    background-color: #fffef0;
}
notification-dialog:global(.primary){
    border-color: var(--color-primary);
    background-color: #f2f7ff;
}
notification-dialog:global(.success){
    border-color: var(--color-success);
    background-color: #e8f3ef;
}
</style>